import apiError from "./api-errors";

const config = {};
config.printExcel = false;
config.showConsole = process.env.REACT_APP_SHOWCONSOLE;
config.readablePath = process.env.REACT_APP_TRACKPATH;
config.env = process.env.REACT_APP_ENV;
config.ROOT_DOMAIN = process.env.REACT_APP_BASE_DOMAIN;
config.GA_TRACKING_ID = window.GA_TRACKING_ID
  ? window.GA_TRACKING_ID
  : process.env.REACT_APP_GA_TRACKING_ID;
config.lang = {
  English: "en",
  Spanish: "es",
  French: "fr",
  German: "de",
  Portugese: "pt",
  Russian: "ru",
  Italian: "it",
  Arabic: "ar",
};
// config.showConsole = false;
config.PREDCITOR_DOMAIN = "/predictor/";
config.BASE_DOMAIN = "/fantasy/";
config.IMG_BASE = "/fantasy/static-assets/build/images/";
config.PUBLIC_API = "/fantasy/static-assets/build";
config.currentSeason = "2021"; //do not chnage this it will affect the cards local storgae
config.currentSeasonghcompt = "current";
config.comp = 3;
config.namespaceKey = "uae-pro-league" + config.currentSeason;
config.GAMING_HUB = window.location.host;
config.langArr = ["en", "ar"];
config.LangNameArr = { en: "Language_EN", ar: "Language_AR" };
config.userLocale = navigator.languages;
config.language = config.lang.Arabic;

config.isVersionChangeTrackKey = "isVersionChangeObj";

if (config.langArr.indexOf(window.location.pathname.split("/")[2]) > -1) {
  config.language = window.location.pathname.split("/")[2];
} else {
  if (config.userLocale.find((obj) => obj.includes(config.lang.Arabic))) {
    config.language = config.lang.Arabic;
  } else {
    config.language = config.lang.English;
  }
}
config.language === config.lang.Arabic && document.body.classList.add("si-ar");

config.enumBoosterTypes = {
  one: ["1", "2", "5", "6", "8"],
  two: ["3", "4"],
  three: ["7"],
};
config.MakeTransfersBoosterIds = ["3", "4"];
config.BASE_DOMAIN_LANG = config.BASE_DOMAIN + config.language + "/";
config.gameName = "Fantasy Football";
config.GAME_NAME = "uaeproleague";
config.shareUrl = window.location.host + "/{{lang}}/" + config.GAME_NAME + "/";
config.COOKIE_GM = "uaeplf_RAW";
config.LoginUrl =
  "https://games-uaepl-int.sportz.io/fantasy/static-assets/login";
config.optType = 1;
config.phaseId = 1;
config.leaguesPageSize = 1000;
config.updateOverviewTimeInt = 60000;
config.publicLeaderBoardTypes = {
  global: 1,
  country: 2,
  club: 3,
  knockout: 4,
};
// config.firstFiters = ["Overall", "Weekday", "Rounds", "Months"];
config.boosterImg = {
  1: "triple-captain",
  2: "bench-booster",
  3: "rich-uncle",
  4: "free-hit",
  5: "park-the-bus",
  6: "all-attack",
  7: "two-captains",
};
config.boosterCaptain = 7;
config.unlimitedBudgetBooster = 3;

config.enumBoosterRules = {
  1: {
    name: "booster_1",
    rule: ["booster_1_1_rule", "booster_1_2_rule"],
  },
  2: {
    name: "booster_2",
    rule: ["booster_2_1_rule", "booster_2_2_rule"],
  },
  3: {
    name: "booster_3",
    rule: ["booster_3_1_rule", "booster_3_2_rule"],
  },
  4: {
    name: "booster_4",
    rule: ["booster_4_1_rule", "booster_4_2_rule"],
  },
  5: {
    name: "booster_5",
    rule: ["booster_5_1_rule", "booster_5_2_rule"],
  },
  6: {
    name: "booster_6",
    rule: ["booster_6_1_rule", "booster_6_2_rule"],
  },
  7: {
    name: "booster_7",
    rule: ["booster_7_1_rule", "booster_7_2_rule"],
  },
  8: {
    name: "booster_8",
    rule: ["booster_8_1_rule", "booster_8_2_rule", "booster_8_3_rule"],
  },
};

config.redirectDefault = config.BASE_DOMAIN_LANG + "home";
config.trend = {
  0: null,
  1: "si-same",
  2: "si-down",
  3: "si-up",
};

config.enumContinentList = {
  Europe: "eu",
  Asia: "as",
};
config.tourId = process.env.REACT_APP_TOURID;
config.manageTeamScreenForPopUp = "/my-team";
config.HeartbeatInterval = 10;
config.PlayerScoringInterval = 10;
config.ScoringInterval = 10;
config.dismissPopUpInterval = 3500;
config.objOrderHomeCard = { one: 1 };
config.apiError = apiError;

config.APINames = {
  webConfig: "web",
  Constraints: "constraintsUrl",
  Trans: "transUrl",
  Fixtures: "fixturesUrl",
  FixturesNew: "fixturesUrlNew",
  Compositions: "compositionUrl",
  Player: "playerUrl",
  TeamList: "teamsUrl",
  Recomendation: "recomendationUrl",
  Login: "loginUrl",
  SocialLogin: "socialLoginUrl",
  SubmitMobile: "otpUrl",
  SubmitEmail: "connectingCustomUrl",
  ConnectingSocialLogin: "ConnectingSocialLoginUrl",
  Registration: "loginRegistrationUrl",
  CustomLogin: "customLoginUrl",
  CustomEmailLogin: "customEmailLoginUrl",
  CookieAccecptUrl: "cookieAccecptUrl",
  Booster: "boosterUrl",
  LimitlessBooster: "limitlessBoosterUrl",
  RemoveBooster: "removeBoosterUrl",
  Logout: "logoutUrl",
  UserProfile: "profileUrl",
  PostTeam: "teamPostUrl",
  Gamedays: "gamedaysUrl",
  GetTeam: "getTeamUrl",
  postTransfer: "teamTransferUrl",
  playerCard: "popupstatsUrl",
  playerCardNew: "popupstatsUrlNew",
  captain: "captainUrl",
  subs: "subsUrl",
  heartBeat: "mixedUrl",
  liveMatch: "liveUrl",
  PrivateLeagues: "privateLeaguesUrl",
  PublicLeagues: "publicLeaguesUrl",
  CreateLeague: "createLeagueUrl",
  RelaunchLeague: "relaunchLeagueUrl",
  JoinLeague: "joinLeagueUrl",
  RejoinLeague: "rejoinLeagueUrl",
  onDeletePreviousLeague: "onDeletePreviousLeagueClickUrl",
  onDeletePreviousMembersLeague: "onDeletePreviousMembersLeagueClickUrl",
  publicLeaderBoardGlobal: "getGlobalLeaderBoard",
  publicLeaderBoardCountry: "getCountryLeaderBoard",
  publicLeaderBoardClub: "getFavouriteTeamLeaderBoard",
  leaderboardFilter: "getLeaderBoardFilter",
  publicLeaderBoardRankGlobal: "getGlobalLeaderBoardRank",
  publicLeaderBoardRankCountry: "getCountryLeaderBoardRank",
  publicLeaderBoardRankClub: "getFavouriteTeamLeaderBoardRank",
  publicLeaderBoardByWeekGlobal: "getGlobalLeaderBoardByWeek",
  publicLeaderBoardByWeekCountry: "getCountryLeaderBoardByWeek",
  publicLeaderBoardByWeekClub: "getFavouriteTeamLeaderBoardByWeek",
  publicLeaderBoardByMonthGlobal: "getGlobalLeaderBoardByMonth",
  publicLeaderBoardByMonthCountry: "getCountryLeaderBoardByMonth",
  publicLeaderBoardByMonthClub: "getFavouriteTeamLeaderBoardByMonth",
  publicLeaderBoardByRoundGlobal: "getGlobalLeaderBoardByRound",
  publicLeaderBoardByRoundCountry: "getCountryLeaderBoardByRound",
  publicLeaderBoardByRoundClub: "getFavouriteTeamLeaderBoardByRound",
  publicLeaderBoardRankKnockout: "getKnockOutLeaderBoardRank",
  matchDetails: "matchDetailsUrl",
  privateLeaderboard: "privateLeaderboardUrl",
  //leaderboard/private/{{guid}}/top
  updateLeagueCodeLinkAchievementUrl: "updateLeagueCodeLinkAchievementUrl",

  Sponsors: "sponsorsUrl",
  GamerCard: "gamerCardUrl",
  Statitics: "statiticsUrl",
  MixApi: "mixApiUrl",

  fetchGamerCard: "fetchGamerCardUrl",
  sharePointsUrl: "sharePointsUrl",

  fetchClubs: "fetchClubsUrl", //not sure still to be added by akshay
  fetchCountries: "fetchCountriesUrl", // not used
  updateFavouriteTeam: "updateFavouriteTeamUrl",
  leagueMembers: "leagueMembersUrl",
  postSuspendLeague: "postSuspendLeagueUrl",
  postRemoveSuspensionLeague: "postRemoveSuspensionLeagueUrl",
  postDeleteLeague: "postDeleteLeagueUrl",
  postLeaveLeague: "postLeaveLeagueUrl",
  updateLeagueName: "updateLeagueNameUrl",
  profanityTeamName: "profanityTeamNameUrl",
  teamnameUpdate: "teamNameUpdateUrl",
  landingPageTrans: "landingPageTransUrl",
  EditorialApi: "EditorialApiURL",
  OtherUsrGamedays: "OtherUserGamedayUrl",
  OtherUsrTeam: "OtherUserTeamUrl",
  geoLocation: "geoLocationUrl",
};

config.matchDetailsStats = {
  GS: {
    icon: "si-goal",
    transKey: "GS",
  },
  GA: {
    icon: "si-assist",
    transKey: "Assist",
  },
  OG: {
    icon: "si-ownGoalIcn",
    transKey: "OG",
  },
  PM: {
    icon: "si-penaltyMissIcn si-penaltyRedIcn",
    transKey: "PM",
  },
  PS: {
    icon: "si-penaltyGreenIcn si-penaltySaveIcn",
    transKey: "PS",
  },
  YC: {
    icon: "si-yellow-card",
    transKey: "YC",
  },
  RC: {
    icon: "si-redCrdIcn",
    transKey: "RC",
  },
  SS: {
    icon: "si-savesIcn",
    transKey: "SS",
  },
  MOM: {
    icon: "si-momw",
    transKey: "MOM",
  },
};

config.APIBusters = {};

config.playerPos = ["GK", "DEF", "MID", "FWD"];

config.emptyValue = null;
config.sortByArrTracking = {
  totPts: "Total points",
  lastGdPoints: "Matchweek points",
  value: "Price",
  selPer: "Selected by %",
  avgPlayerPts: "Average points",
  avgPlayerValue: "AvgPlayerValue",
  gS: "Goals scored",
  assist: "Assists",
  cS: "Clean sheets",
};

// [
//   "selPer",
//   "selInPer",
//   "selOutPer",
//   "avgPlayerPts",
//   "avgPlayerValue",
//   "gS",
//   "assist",
//   "cS",
//   "gOB",
// ];

config.sortByArr = [
  {
    id: 3,
    label: "Price",
    sortId: "Value",
    labelTrans: "value",
    selected: false,
  },
  {
    id: 1,
    label: "Total points",
    labelTrans: "totPts",
    selected: false,
    sortId: "Overallpoints",
  },
  {
    id: 2,
    label: "Matchweek points",
    sortId: "CurrGamedayPoints",
    labelTrans: "lastGdPoints",
    selected: false,
  },
  {
    id: 4,
    label: "Selected by %",
    sortId: "SelectedPercentage",
    labelTrans: "selPer",
    selected: false,
  },
  // {
  //   id: 5,
  //   label: "Average points",
  //   sortId: "",
  //   labelTrans: "avgPlayerPts",
  //   selected: false,
  // },
  // {
  //   id: 6,
  //   label: "AvgPlayerValue",
  //   sortId: "AvgPlayerValue",
  //   labelTrans: "avgPlayerValue",
  //   selected: false,
  // },
  {
    id: 7,
    label: "Goals scored",
    sortId: "GoalScored",
    labelTrans: "gS",
    selected: false,
  },
  {
    id: 8,
    label: "Assists",
    sortId: "GoalAssist",
    labelTrans: "assist",
    selected: false,
  },
  {
    id: 9,
    label: "Clean sheets",
    sortId: "CleanSheet",
    labelTrans: "cS",
    selected: false,
  },
];

config.sortByShortKey = {
  totPts: "pts_cap_txt",
  lastGdPoints: "pts_cap_txt",
  selPer: "percent",
  gS: "goalScoredShort",
  assist: "assistShort",
  cS: "cleanSheetShort",
  value: "value",
};
config.matchStatus = {
  pre: 0,
  live: 1,
  post: 2,
};
config.fixtureStatus = {
  isUpComing: 1,
  isOpen: 5,
  isLock: 2,
  isSubstitution: 3,
  isFinished: 4,
  isNewUser: 6,
};

config.modes = {
  transfer: 0,
  live: 1,
  substitution: 2,
  viewpoint: 3,
};

config.screenMode = {
  transfer: 0,
  "view-manage-team": 1,
  substitution: 2,
  "create-team": 3,
};

config.enumTeamPlayingStatus = {
  willPlay: 0,
  isPlaying: 1,
  hasPlayed: 2,
};
config.enumFallBackName = {
  home: "Home",
  "create-team": "Create Team",
  "select-captain": "Select Captain",
  "save-team-name": "Save Team Name",
  "save-team": "Save Team",
  "my-team": "My Team",
  "manage-team": "Manage Team",
  "transfer-summary": "Transfer Summary",
  leagues: "Leagues",
  "league-settings": "League Settings",
  "public-league-leaderboard": "Public League Leaderboard",
  "league-leaderboard": "League Leaderboard",
  "my-profile": "My Profile",
  "my-rules": "My Rules",
  "my-terms": "My Terms",
  privacy: "Privacy",
};

config.liveScoringStates = {
  live: 3,
  post: 1,
};

config.positionMap = {
  1: {
    skill: "Goalkeepers",
    key: "GK",
    map: 1,
    skillTrans: "gkTxtLong",
    singSkillTrans: "goalkeeper",
    skillShortTrans: "gk",
  },
  2: {
    skill: "Defenders",
    key: "DEF",
    map: 2,
    skillTrans: "defTxtLong",
    singSkillTrans: "defender",
    skillShortTrans: "def",
  },
  3: {
    skill: "Midfielders",
    key: "MDF",
    map: 3,
    skillTrans: "midTxtLong",
    singSkillTrans: "midfielder",
    skillShortTrans: "mid",
  },
  4: {
    skill: "Forwards",
    key: "FWD",
    map: 4,
    skillTrans: "fwdTxtLong",
    singSkillTrans: "forward",
    skillShortTrans: "fwd",
  },
};

config.priceTrans = {
  5: "€5m",
  6: "€6m",
  7: "€7m",
  8: "€8m",
  9: "€9m",
  10: "€10m",
  11: "€11m",
  12: "€12m",
  13: "€13m",
  0: "Unlimited",
  1: "Affordable",
  12.5: "€12.5m",
  11.5: "€11.5m",
  10.5: "€10.5m",
  9.5: "€9.5m",
  8.5: "€8.5m",
  7.5: "€7.5m",
  6.5: "€6.5m",
  5.5: "€5.5m",
  4.5: "€4.5m",
};

config.EnumPosition = {
  Goalkeepers: 1,
  Defenders: 2,
  Midfielders: 3,
  Forwards: 4,
};
config.pos = [4, 3, 2, 1];
config.EnumMinPositionNos = {};
config.EnumMinPositionNos[config.EnumPosition.Goalkeepers] = 1;
config.EnumMinPositionNos[config.EnumPosition.Defenders] = 3;
config.EnumMinPositionNos[config.EnumPosition.Midfielders] = 3;
config.EnumMinPositionNos[config.EnumPosition.Forwards] = 1;
config.EnumMaxPositionNosBench = {};
config.EnumMaxPositionNosBench[config.EnumPosition.Goalkeepers] = 1;
config.EnumMaxPositionNosBench[config.EnumPosition.Defenders] = 2;
config.EnumMaxPositionNosBench[config.EnumPosition.Midfielders] = 2;
config.EnumMaxPositionNosBench[config.EnumPosition.Forwards] = 2;

config.playerFiltersRaw = {
  sortBy: "totPts",
  searchString: "",
  teamIds: [],
  teamNamesObj: [],
  priceFilterSelected: "",
  priceFilterObj: [],
  curPosFilter: 1,
  skillId: [],
  filterCount: 0,
  playerStatus: [
    {
      id: "I",
      trackLable: "Injured players",
      label: "injured",
      labelTrck: "Injured",
      siIcon: "si-center",
      active: false,
    },
    {
      id: "S",
      trackLable: "Suspended players",
      label: "suspended",
      labelTrck: "Suspended",
      siIcon: "si-center",
      active: false,
    },
  ],
  playerRecomendation: ["playerRecomendationdDefault"],
};
config.playerFilters = {
  sortBy: "value",
  searchString: "",
  teamIds: [],
  teamNamesObj: [],
  priceFilterSelected: "",
  priceFilterObj: [],
  curPosFilter: 1,
  skillId: [],
  filterCount: 0,
  playerStatus: [
    {
      id: "I",
      trackLable: "Injured players",
      label: "injured",
      labelTrck: "Injured",
      siIcon: "si-center",
      active: false,
    },
    {
      id: "S",
      trackLable: "Suspended players",
      label: "suspended",
      labelTrck: "Suspended",
      siIcon: "si-center",
      active: false,
    },
  ],
  playerRecomendation: ["playerRecomendationdDefault"],
};

config.avatarSize = "45@2x";
config.MAX_COUNT_FOR_PERCENTAGE = 17;
config.MAX_TEAM_NAME_LENGTH = 25;
config.MIN_TEAM_NAME_LENGTH = 3;
config.MIN_TEAM_NAME_LENGTH = 3;
config.MIN_LEAGUE_NAME_LENGTH = 2;
config.MAX_LEAGUE_NAME_LENGTH = 20;
config.MIN_LEAGUE_CODE_LENGTH = 5;
config.MAX_LEAGUE_CODE_LENGTH = 20;
config.threshHold = 0;
config.playerRecomendationDefault = "playerRecomendationdDefault";
config.skillsFilterWeb = [
  {
    skill: "All",
    key: "All",
    map: 0,
    skillTrans: "All",
  },
  {
    skill: "Goal Keepers",
    key: "GK",
    map: 1,
    skillTrans: "gkTxtLong",
  },
  {
    skill: "Defenders",
    key: "DEF",
    map: 2,
    skillTrans: "defTxtLong",
  },
  {
    skill: "Midfielders",
    key: "MID",
    map: 3,
    skillTrans: "midTxtLong",
  },
  {
    skill: "Forwards",
    key: "FWD",
    map: 4,
    skillTrans: "fwdTxtLong",
  },
];

config.noPitchScreens = ["/save-team-name"];

config.addAdsclass = [
  "/create-team",
  "/select-captain",
  "/my-team/:mDID?",
  "/team/:GUID/:FULLNAME/:RANK/:GDID?/:PHID?",
  "/manage-team",
];

config.skillsFilterMob = [
  {
    skill: "Goal Keepers",
    key: "GK",
    map: 1,
  },
  {
    skill: "Defenders",
    key: "DEF",
    map: 2,
  },
  {
    skill: "Midfielders",
    key: "MID",
    map: 3,
  },
  {
    skill: "Forwards",
    key: "FWD",
    map: 4,
  },
];

config.statusIcons = {
  I: {
    class: "si-icon si-bg--error",
    text: "injured",
    bioClass: "si-injured",
    textTrack: "Injured",
  },
  S: {
    class: "si-icon si-bg--error",
    text: "suspended",
    bioClass: "si-suspended",
    textTrack: "Suspended",
  },
  NIS: {
    class: "si-icon si-bg--error",
    text: "not_in_squad",
    bioClass: "si-not-in-squad",
    textTrack: "Not in squad",
  },
  E: {
    class: "si-icon si-bg--error",
    text: "eliminated",
    bioClass: "si-eliminated",
    textTrack: "Eliminated",
  },
  B: {
    class: "si-icon si-bg--bench",
    text: "bench",
    bioClass: "si-bench",
    textTrack: "Bench",
  },
  W: {
    class: "si-icon si-bg--warning",
    text: "already_played",
    bioClass: "si-warning",
    textTrack: "Already played",
  },
  P: {
    class: "si-icon si-bg--playing",
    text: "startingXI",
    bioClass: "si-starting11",
    textTrack: "Starting XI",
  },
  R: {
    class: "si-icon si-bg--white",
    text: "sentOff",
    bioClass: "si-red-card",
    textTrack: "Red card",
  },
  Y: {
    class: "si-icon si-bg--white",
    text: "sentOff",
    bioClass: "si-yellow-card",
    textTrack: "Yellow card",
  },
  D: {
    class: "si-icon si-bg--warning",
    text: "doubtful",
    bioClass: "si-doubtful",
    textTrack: "Doubtful",
  },
};

config.warningStatus = "W";
config.enumMdCardStatus = { fixture: "FX_CARD", points: "PT_CARD" };
config.enumPlayerStatus = {
  Available: "0",
  Doubtful: "1",
  Suspended: "2",
  Injured: "3",
};
config.objCheckPlayerStatus = {};
config.enumMatchStatus = {
  isUpComing: 0,
  isLock: 1,
  isFinished: 2,
};

config.headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
  entity: "d3tR0!t5m@sh",
  "Access-Control-Expose-Headers": "Date",
};

//to be moved to webconfig
// config.bustersConfig = {
//     '/team-create': ['/team', '/gamercard/fetch', '/gamedays'],
//     '/transfer': ['/team', '/gamercard/fetch', '/fixtures_{TourId}_{languageCode}_{matchdayId}.json'],
//     '/booster': ['/team', '/gamercard/fetch'],
//     '/substitution': ['/team', '/gamercard/fetch'],
//     '/captain': ['/team', '/gamercard/fetch'],
//     '/create': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
//     '/join': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
//     '/leave': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
//     '/relaunch': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
//     '/re-join': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
//     '/delete': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
//     '/prv-season-delete': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
//     '/prv-season-member-delete': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
//     '/suspend': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
//     '/removesuspension': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
//     '/league-name-update': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
//     '/user/update-team-name': ['/leagues', '/home-leagues', '/leagueleaderboard', '/members', '/gamercard/fetch'],
//     '/subscribe': ['/gamercard/fetch', '/subscribe-info'],
//     '/update-team-name': ['/subscribe-info'],
//     '/bust-after-status-change': ['/team', '/gamercard/fetch', '/gamedays', '/constraints', '/fixtures_{TourId}_{languageCode}_{matchdayId}.json'],
//     '/match-details': ['/match-details'],
//     '/update-fav-team': ['/home-leagues']

// };

config.bustersConfig = {
  "/team": ["/team", "/gamercard", "/gamedays", "/opponent-gamedays"],
  "/transfer": [
    "/team",
    "/gamercard",
    "fixtures/fixtures_{{platformId}}_{{lang}}.json",
  ],
  "/booster": ["/team", "/gamercard", "/top"],
  "/substitution": ["/team", "/gamercard", "/gamedays"],
  "/captain": ["/team", "/gamercard", "/gamedays"],
  "/create": ["/leagues", "/leaguelist", "/top", "/members", "/gamercard"],
  "/join": ["/leagues", "/leaguelist", "/top", "/members", "/gamercard"],
  "/leave": ["/leagues", "/leaguelist", "/top", "/members", "/gamercard"],
  "/relaunch": ["/leagues", "/leaguelist", "/top", "/members", "/gamercard"],
  "/re-join": ["/leagues", "/leaguelist", "/top", "/members", "/gamercard"],
  "/delete": ["/leagues", "/leaguelist", "/top", "/members", "/gamercard"],
  "/prv-season-delete": [
    "/leagues",
    "/leaguelist",
    "/top",
    "/members",
    "/gamercard",
  ],
  "/prv-season-member-delete": [
    "/leagues",
    "/leaguelist",
    "/top",
    "/members",
    "/gamercard",
  ],
  "/suspend": ["/leagues", "/leaguelist", "/top", "/members", "/gamercard"],
  "/unsuspend": ["/leagues", "/leaguelist", "/top", "/members", "/gamercard"],
  "/removesuspension": [
    "/leagues",
    "/leaguelist",
    "/top",
    "/members",
    "/gamercard",
  ],
  "/rename": ["/leagues", "/leaguelist", "/top", "/members", "/gamercard"],
  "/user/update-team-name": [
    "/leagues",
    "/leaguelist",
    "/top",
    "/members",
    "/gamercard",
  ],
  "/subscribe": ["/gamercard", "/subscribe-info"],
  "/update-team-name": ["/subscribe-info", "/team"],
  "/bust-after-status-change": [
    "/team",
    "/gamercard",
    "/gamedays",
    "/constraints",
    "/fixtures_{TourId}_{languageCode}_{matchdayId}.json",
  ],
  "/match-details": ["/match-details"],
  "/update-fav-team": ["/public", "/leaders", "/rank"],
  "/team-name-update": ["/team", "/gamercard"],
};

config.wildCardStatus = {
  notStarted: 1,
  startedAndNotUsed: 2,
  usedInCurrent: 3,
  usedInBefore: 4,
  usedInCurrentTemp: 5,
  usedInNext: 6,
};
config.limitlessBoosterStatus = {
  notStarted: 1,
  startedAndNotUsed: 2,
  usedInCurrent: 3,
  usedInBefore: 4,
  usedInCurrentTemp: 5,
  usedInNext: 6,
};

config.lang2D = Object.keys(config.lang).map((key) => {
  return config.lang[key];
});

let subURL = window.location.href.split(window.location.host)[1];
let possibleLang = subURL.split("/").filter(Boolean)[1];
let defaultLanguage = "en";
const DOMAIN = window.location.host;
config.CURRENT_LANGUAGE =
  config.lang2D.indexOf(possibleLang) > -1 ? possibleLang : defaultLanguage;

if (!config.CURRENT_LANGUAGE) {
  config.CURRENT_LANGUAGE = defaultLanguage;
}

config.WebConfigUrl = config.BASE_DOMAIN + "config/web";

config.FEEDBASEPATH = config.BASE_DOMAIN + "feeds/";
config.FEEDBASEPATHLIVE = "";
config.APIBASEPATH = config.BASE_DOMAIN + "services/";
config.LOGINAPIBASEPATH = config.APIBASEPATH + "session/user/";
config.playerImgBase = "";
config.landingPageClients = ["fantasy", "fifa"];
config.PS5Obj = {};

config.mixApiLiveInterval = 20000;
config.liveScoringInterval = 30000;

const isMobile = () => {
  return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};
config.isMobile = isMobile();

config.socialLogin = {
  facebook: "fb",
  google: "google",
  twitter: "twitter",
};

config.enumClientIdName = {
  1: "Gmail",
  2: "Facebook",
  3: "Twitter",
  5: "Email-Id",
};

config.loginScreenMode = {
  main: 1,
  mobileNo: 2,
  otp: 3,
  register: 4,
  linkAccounts: 5,
  changeNumber: 6,
  linkNewLogin: 7,
  availableAccounts: 8,
  emailOtp: 9,
  emailProtected: 10,
  emailLinked: 11,
  unableRegister: 12,
};
config.platformId = 1;
config.dummyUser = {
  optType: 1,
  platformId: 1,
  userId: 123323,
  socialId: 123323,
  gigyaId: "9b920fe8-5f84-11ea-afa0-067f46be74t8",
  fullName: "romit",
  countryCode: "NAM",
  favTeamId: 0,
  accessToken:
    "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImMxNjRkM2NmMmNjYjUwOTNhZWYzZTZlM2Y0NmFmZDMzZDJmMWYyOGQxYmJkNzUzMDhkMmM1MmEyY2Y5NjZlZDhmYTQwMTMyYWMwOGMyMTM1In0.eyJhdWQiOiIyIiwianRpIjoiYzE2NGQzY2YyY2NiNTA5M2FlZjNlNmUzZjQ2YWZkMzNkMmYxZjI4ZDFiYmQ3NTMwOGQyYzUyYTJjZjk2NmVkOGZhNDAxMzJhYzA4YzIxMzUiLCJpYXQiOjE1ODQ0MjM1NzYsIm5iZiI6MTU4NDQyMzU3NiwiZXhwIjoxNTg0NTA5OTc2LCJzdWIiOiIxMjU3ODYiLCJzY29wZXMiOltdfQ.Zbi_SWNldcTzoQ6VhWh-5Ci1dcTzIqIJpiINZzcDFFAHdqiKosqQBFtRrE0Q4b2IK3rUEQyoyqNd_wE6e2w32Ka_K16dxkQd8zyuvPgNS4Gu5M8FHcbXESeR_mJXKR-ky6wfD3MRtpZ-Cq0pYBc_Qkdp4oZNduAHeZDN5idCM0LdPcRwOshdfV6R23iLIWpp68M2qoerAA4adXqpC0IgK3z0SVgdQVo3tFIdqGqQ62Zv5GsAVKzW-hEmAojWYzceBC7ERJCfQ4wvIF_zyN5xeBXIp40XzOHi2y0UI_Kgz86rlA5DZ_FNClnWKyDUpE0ocx7GaNHxP-TPc7yMty8J0j11EZsIhsnczfcO79xZdykyqXHFQyIf2tI3l9-nY35rrS5HdAkqNw-586bPFABRty4ZWJXd1HxSvDQKT2Kyvwo7HPcQJQs5EHd00dnhTnKp93OBkhnXyFBL3DpKfEvww4_QVuT0AyZiWR50r-Az2m4w-oVEdqWgplVlKjmWXNQFnF6RHLk076pXJICs54XXmEWLF5ej_joU1XOh3jPhKe5xlHf9XcS6cjz8hymfmEN-CZ06MVm9DOh84ok5I4LGSpZcsy3IueaAykdRPM9SjGONRl2jmfjYr69h-BtKIymOB1Bl4wnHga6sKteEl8sLGiMqdHTos4sdyX7JOvdBMcs",
};
config.sampleGuid = {
  socialId: "123323",
  gigyaId: "9b920fe8-5f84-11ea-afa0-067f46be74t8",
  fullName: "romit",
  isTeamExists: 1,
  countryId: 326,
  countryName: "Namibia",
  guid: "f6f654c4-69b7-11ea-a838-067f46be7e2a",
  favTeamId: "0",
  teamName: "hthth",
  isGdprActive: 0,
};

config.leaguesObject = {
  LeagueId: "LeagueId",
  PubLeagueId: "Id",
  LeagueName: "LeagueName",
  LeagueCode: "leagueCode",
  TotalMembers: "TotalMembers",
  TotalMembersDisplay: "Notation",
  PointsGamedayId: "PointsGamedayId",
  IsUserAdmin: "IsUserAdmin",
  Members: "Members",
  Trend: "Trend",
  UserId: "UserId",
  GUID: "GUID",
  UserName: "UserName",
  TeamName: "TeamName",
  CurrentGDPoints: "CurrentGDPoints",
  Points: "Points",
  LP_GamedayId: "Lp_GamedayId",
  ShareLoad: "ShareLoad",
  Rank: "Rank",
  LeagueIdPrv: "lgid",
};

config.fixturesObject = {
  GDID: "mdId",
  GDNo: "",
  PhID: "phId",
  GDIsLckd: "gdIsLocked",
  GDIsCurr: "gdIsCurrent",
  SubsAllowed: "subsAllowed",
  MaxSubsCF: "",
  Deadline: "",
  MatchDay: "",
  RoundId: "roundId",
  Round: "round",
  MdIsLckd: "mdIsLocked",
  MdIsCurr: "mdIsCurrent",
  IsActNewUsr: "isActNewUser",
  ShowLeaderboards: "showLeaderboards",
  mDiD: "mdId",
};

config.publicLeaderBoardObject = {
  UserId: "usid",
  UserTeamId: "temid",
  GUID: "guid",
  TeamName: "teamName",
  FullName: "usrname",
  Rank: "rank",
  Trend: "trnd",
  GamedayPoints: "currentGamedayPoints",
  Points: "points",
};

config.privateLeaderboardObject = {
  UserId: "usid",
  UserTeamId: "ustmid",
  Trend: "trnd",
  GUID: "guid",
  FullName: "usrname",
  TeamName: "teamName",
  Points: "ovpt",
  Rank: "rnk",
  PhasePoints: "phasePoints",
  GamedayPoints: "gamedayPoints",
  CurrentGamedayPoints: "currentGamedayPoints",
  AvatarUrl: "avatarId",
};

config.leagueMembers = {
  mLeagueMembersSummary: "leagueDetails",
  mLeagueMembersDetails: "memberDetails",
  TotalMembers: "totalMember",
  TotalMembersDisplay: "totalMembersNotation",
  isAdmin: "isAdmin",
  IsDefaultLeague: "isDefaultLeague",
  LeagueName: "leagueName",
  LeagueCode: "leagueCode",
  IsLocked: "IsLocked",
  UserGuid: "GUID",
  UserId: "UserId",
  UserName: "FullName",
  UserTeamId: "UserTeamId",
  ShareLoad: "ShareLoad",
};

config.maxLeaderboardPages = 20;

/** Gamer Card  */

config.enumGamerCard = {
  preNT: "TN_PRTR", // Create team : Pre tournament with no user team
  inNT: "TN_INTR", // Create team : In Tournament with no user team
  liveYT: "TY_LIVE", // Live
  postYT: "TY_VPNT", // post match view points
  subYT: "TY_SUBT", // Substitution
  transYT: "TY_TRAN", // Transfer
  finalRoundNT: "TN_GDED", // Final round locked  : User team does not  exists
  tournEndNT: "TN_TRED", // Tournament end : User team does not  exists
  tournEndYT: "TY_TRED", // Tournament end : User team exists
};

config.trackclickEvents = {
  home: {
    action: "home_menu_bar",
    category: "Menu Bar",
    label: "Home",
  },
  predictor: {
    action: "predictor_menu_bar",
    category: "Menu Bar",
    label: "Predictor",
  },
  myteam: {
    action: "myteam_menu_bar",
    category: "Menu Bar",
    label: "My Team",
  },
  createteam: {
    action: "createteam_menu_bar",
    category: "Menu Bar",
    label: "Create Team",
  },
  manageteam: {
    action: "manageteam_menu_bar",
    category: "Menu Bar",
    label: "Manage Team",
  },
  leagues: {
    action: "leagues_menu_bar",
    category: "Menu Bar",
    label: "Leagues",
  },
  stats: {
    action: "stats_menu_bar",
    category: "Menu Bar",
    label: "Statistics",
  },
  profile: {
    action: "profile_menu_bar",
    category: "Menu Bar",
    label: "My Profile",
  },
  rules: {
    action: "rules_menu_bar",
    category: "Menu Bar",
    label: "Rules",
  },
  terms: {
    action: "terms_menu_bar",
    category: "Menu Bar",
    label: "Terms",
  },
  privacy: {
    action: "privacy_menu_bar",
    category: "Menu Bar",
    label: "Privacy",
  },
  en: {
    action: "en_language_selection",
    category: "Language Selection",
    label: "English Language",
  },
  ar: {
    action: "ar_language_selection",
    category: "Language Selection",
    label: "Arabic Language",
  },
  createLeague: {
    action: "create_league",
    category: "League",
    label: "Create League",
  },
  joinLeague: {
    action: "join_league",
    category: "League",
    label: "Join League",
  },
  createLeagueSuccess: {
    action: "create_league_success",
    category: "League",
    label: "Create League Success",
  },
  joinLeagueSuccess: {
    action: "join_league_success",
    category: "League",
    label: "Join League Success",
  },
  customLogin: {
    action: "custom_login",
    category: "Login",
    label: "Custom Login",
  },
  resendOtp: {
    action: "resend_otp",
    category: "Login",
    label: "Resend Otp",
  },
  viewPlayersManageTeam: {
    action: "view_players_manage_team",
    category: "Manage Team",
    label: "View Players",
  },
  viewPlayersCreateTeam: {
    action: "view_players_create_team",
    category: "Create Team",
    label: "View Players",
  },
  formationManageTeam: {
    action: "formation_manage_team",
    category: "Manage Team",
    label: "Formation",
  },
  formationCreateTeam: {
    action: "formation_create_team",
    category: "Create Team",
    label: "Formation",
  },
  autoCompleteManageTeam: {
    action: "auto_complete_manage_team",
    category: "Manage Team",
    label: "Auto Complete",
  },
  autoCompleteCreateTeam: {
    action: "auto_complete_create_team",
    category: "Create Team",
    label: "Auto Complete",
  },
  formationMyTeam: {
    action: "formation_my_team",
    category: "My Team",
    label: "Formation",
  },
  calender: {
    action: "calender",
    category: "Calender",
    label: "Calender",
  },
  makeTransferMyTeam: {
    action: "make_transfer_my_team",
    category: "My Team",
    label: "Make Transfer",
  },
  makeTransferHome: {
    action: "make_transfer_home",
    category: "Home",
    label: "Make Transfer",
  },
  saveTeamCreateTeam: {
    action: "save_team_create_team",
    category: "Create Team",
    label: "Save Team",
  },
  saveTeamManageTeam: {
    action: "save_team_manage_team",
    category: "Manage Team",
    label: "Save Team",
  },
  resetCreateTeam: {
    action: "reset__create_team",
    category: "Create Team",
    label: "Reset",
  },
  appStoreTracking: {
    action: "app_store_tracking",
    category: "Get App",
    label: "App Store",
  },
  playStoreTracking: {
    action: "play_store_tracking",
    category: "Get App",
    label: "Play Store",
  },
  sponsor1: {
    action: "sponsor_1",
    category: "Sponsor Tracking",
    label: "Sponsor 1",
  },
  sponsor2: {
    action: "sponsor_2",
    category: "Sponsor Tracking",
    label: "Sponsor 2",
  },
  sponsor3: {
    action: "sponsor_3",
    category: "Sponsor Tracking",
    label: "Sponsor 3",
  },
  sponsor4: {
    action: "sponsor_4",
    category: "Sponsor Tracking",
    label: "Sponsor 4",
  },
  sponsor5: {
    action: "sponsor_5",
    category: "Sponsor Tracking",
    label: "Sponsor 5",
  },
  sponsor6: {
    action: "sponsor_6",
    category: "Sponsor Tracking",
    label: "Sponsor 6",
  },
  sponsor7: {
    action: "sponsor_7",
    category: "Sponsor Tracking",
    label: "Sponsor 7",
  },
  sponsor8: {
    action: "sponsor_8",
    category: "Sponsor Tracking",
    label: "Sponsor 8",
  },
  sponsor9: {
    action: "sponsor_9",
    category: "Sponsor Tracking",
    label: "Sponsor 9",
  },
  sponsor10: {
    action: "sponsor_10",
    category: "Sponsor Tracking",
    label: "Sponsor 10",
  },
  sponsor11: {
    action: "sponsor_11",
    category: "Sponsor Tracking",
    label: "Sponsor 11",
  },
  sponsor12: {
    action: "sponsor_12",
    category: "Sponsor Tracking",
    label: "Sponsor 12",
  },
  sponsor13: {
    action: "sponsor_13",
    category: "Sponsor Tracking",
    label: "Sponsor 13",
  },
  sponsor14: {
    action: "sponsor_14",
    category: "Sponsor Tracking",
    label: "Sponsor 14",
  },
  sponsor15: {
    action: "sponsor_15",
    category: "Sponsor Tracking",
    label: "Sponsor 15",
  },
};

let arrPreTornamentUnkownFixtureOrder = [];
let arrPreTornamentKownFixtureOrder = [];
let arrStartOfMatchDayBefore6Hour = [];
let arrStartOfMatchDayMoreThan6Hour = [];
let arrPreLineupsAnnounced = [];
let arrLive = [];
let arrPointsBeingCalculated = [];
let arrPointsOk = [];
let arrEndOfMatchDay = [];
let arrLongBreak = [];
let arrPostTournament = [];

config.enumTrend = {
  1: "si-tie",
  2: "si-winner",
  3: "si-loser",
  4: "si-winner",
  0: "",
};
config.enumFnTeamCard = [
  (objDate) => {
    let value = objDate.ms_Diff;
    //23hr 59min
    if (value > 86399000) {
      return {
        color: "#19C201",
        percent: 100,
        dtKey: "days",
        trans: objDate.days == 1 ? "day" : "days",
        leftTime: objDate.days,
        altTrans: objDate.days == 1 ? "Day" : "Days",
        msDiff: value,
        maxTime: 1209599000,
        jPlusStartPosition: 50,
        jPercentageBy: 50,
      };
    }
    return null;
  },
  (objDate) => {
    let value = objDate.ms_Diff;
    //86340000 23hr 59min
    if (value <= 86399000 && value > 3599000) {
      //3540000 as 59 min
      return {
        color: "#FA9263",
        percent: 50,
        dtKey: "hours",
        trans: objDate.hours == 1 ? "hour" : "hours",
        leftTime: objDate.hours,
        altTrans: objDate.hours == 1 ? "Hour" : "Hours",
        msDiff: value,
        maxTime: 86399000,
        jPlusStartPosition: 25,
        jPercentageBy: 25,
      };
    }
    return null;
  },
  (objDate) => {
    let value = objDate.ms_Diff;
    //59min 59sec
    if (value <= 3599000) {
      if (value > 0) {
        return {
          color: "#FF0202",
          percent: 25,
          dtKey: "minutes",
          trans: objDate.minutes == 1 ? "minute" : "minutes",
          leftTime: objDate.minutes,
          altTrans: objDate.minutes == 1 ? "Minute" : "Minutes",
          msDiff: value,
          maxTime: 3599000,
          jPlusStartPosition: 0,
          jPercentageBy: 25,
        };
      } else {
        return {
          color: "#FF0202",
          percent: 25,
          dtKey: "minutes",
          trans: objDate.minutes == 1 ? "minute" : "minutes",
          leftTime: 0,
          altTrans: objDate.minutes == 1 ? "Minute" : "Minutes",
          msDiff: 0,
          maxTime: 3599000,
          jPlusStartPosition: 0,
          jPercentageBy: 25,
        };
      }
    }
    return null;
  },
];
/** */
config.list = "";
config.cardConstants = {};
config.reverseId = 10;
config.otpTimer = 60;

config.popUpStat = {
  OnField: { id: "OnField" },
  GoalScored: { id: "GoalScored" },
  Assist: { id: "Assist" },
  CleanSheet: { id: "CleanSheet" },
  PenaltyEarned: { id: "PenaltyEarned" },
  PenaltyCon: { id: "PenaltyCon" },
  PenaltySave: { id: "PenaltySave" },
  PenaltyMiss: { id: "PenaltyMiss" },
  PenaltyAssistWin: { id: "PenaltyAssistWin" },
  OutOfBoxGoal: { id: "OutOfBoxGoal" },
  GoalsCon: { id: "GoalsCon" },
  YellowCard: { id: "YellowCard" },
  RedCard: { id: "RedCard" },
  GoalsSaved: { id: "GoalsSaved" },
  OwnGoals: { id: "OwnGoals" },
  Bonus: { id: "Bonus" },
};
config.MAX_PHONE_LENGTH = 12;
config.MIN_PHONE_LENGTH = 3;
config.limit = 25;
config.loadMoreLimit = 25;

export default config;
